var _clipPath, _filter, _rect, _g, _clipPath2, _filter2, _rect2, _g2, _clipPath3, _filter3, _rect3, _g3, _filter4, _rect4, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 730 486",
    width: 730,
    height: 486,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "__element_4106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "__element_4111",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4110",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_4111)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.75,32.75)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,315.25,210.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M82,209.75 C82,209.75 -315,210 -315,210 C-315,210 -250.11900329589844,-14.793999671936035 -250.11900329589844,-14.793999671936035 C-250.11900329589844,-14.793999671936035 -243.76300048828125,-47.117000579833984 -243.76300048828125,-47.117000579833984 C-243.76300048828125,-47.117000579833984 -239.25900268554688,-70.01799774169922 -239.25900268554688,-70.01799774169922 C-239.25900268554688,-70.01799774169922 -233.16700744628906,-101 -233.16700744628906,-101 C-233.16700744628906,-101 -190.16700744628906,-104.75 -190.16700744628906,-104.75 C-190.16700744628906,-104.75 -177.16400146484375,-84.64900207519531 -177.16400146484375,-84.64900207519531 C-177.16400146484375,-84.64900207519531 -175.25100708007812,-79.59300231933594 -175.25100708007812,-79.59300231933594 C-175.25100708007812,-79.59300231933594 -145.1840057373047,-35.189998626708984 -145.1840057373047,-35.189998626708984 C-145.1840057373047,-35.189998626708984 -145.08399963378906,-35.05400085449219 -145.08399963378906,-35.05400085449219 C-145.08399963378906,-35.05400085449219 82,209.75 82,209.75z"
  })))))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__element_4115"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L730,0 L730,486 L0,486z"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "__element_4119",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4118",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_4119)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.300000190734863,0,0,5.300000190734863,-7.018999099731445,-540.05322265625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.639999866485596,119.44400024414062)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    fill: "rgb(160,143,213)",
    fillOpacity: 1,
    d: " M2.8289999961853027,-2.8289999961853027 C4.390999794006348,-1.2669999599456787 4.390999794006348,1.2660000324249268 2.8289999961853027,2.828000068664551 C1.2669999599456787,4.389999866485596 -1.2669999599456787,4.389999866485596 -2.8289999961853027,2.828000068664551 C-4.390999794006348,1.2660000324249268 -4.390999794006348,-1.2669999599456787 -2.8289999961853027,-2.8289999961853027 C-1.2669999599456787,-4.390999794006348 1.2669999599456787,-4.390999794006348 2.8289999961853027,-2.8289999961853027z"
  })))))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "__element_4123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L730,0 L730,486 L0,486z"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "__element_4127",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4126",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_4127)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.300000190734863,0,0,5.300000190734863,-7.018999099731445,-540.05322265625)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.639999866485596,119.44400024414062)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    fill: "rgb(160,143,213)",
    fillOpacity: 1,
    d: " M2.7339999675750732,-2.26200008392334 C3.6760001182556152,-0.9079999923706055 3.6760001182556152,0.6010000109672546 2.9230000972747803,2.309999942779541 C2.0320000648498535,4.330999851226807 -1.2669999599456787,4.389999866485596 -2.8289999961853027,2.828000068664551 C-4.390999794006348,1.2660000324249268 -4.390999794006348,-1.2669999599456787 -2.8289999961853027,-2.8289999961853027 C-1.2669999599456787,-4.390999794006348 1.4730000495910645,-4.074999809265137 2.7339999675750732,-2.26200008392334z"
  })))))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "__element_4146",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4145",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_4146)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.75,32.75)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,315.25,210.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M315,210 C315,210 -315,210 -315,210 C-315,210 -315,-210 -315,-210 C-315,-210 315,-210 315,-210 C315,-210 315,210 315,210z"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_4152",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.75,32.75)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,315.25,210.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M315,210 C315,210 77,210 77,210 C77,210 -157.5,-176.25 -157.5,-176.25 C-157.5,-176.25 -315,-111 -315,-111 C-315,-111 -315,-150.75 -315,-150.75 C-315,-150.75 -230.875,-148.5 -211.625,-157.5 C-192.375,-166.5 -171.5,-210 -171.5,-210 C-171.5,-210 315,-210 315,-210 C315,-210 315,210 315,210z"
  })))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__element_4106)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4110)",
    style: {
      display: "block"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0000001192092896,0,0,1.0000001192092896,12.933001518249512,-26.444015502929688)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.639999866485596,119.44400024414062)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    fill: "rgb(160,143,213)",
    fillOpacity: 1,
    d: " M2.8289999961853027,-2.8289999961853027 C4.390999794006348,-1.2669999599456787 4.390999794006348,1.2660000324249268 2.8289999961853027,2.828000068664551 C1.2669999599456787,4.389999866485596 -1.2669999599456787,4.389999866485596 -2.8289999961853027,2.828000068664551 C-4.390999794006348,1.2660000324249268 -4.390999794006348,-1.2669999599456787 -2.8289999961853027,-2.8289999961853027 C-1.2669999599456787,-4.390999794006348 1.2669999599456787,-4.390999794006348 2.8289999961853027,-2.8289999961853027z"
  }))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4118)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__element_4115)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4145)",
    style: {
      display: "block"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.093017578125,-26.92999267578125)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,363.6830139160156,292.8110046386719)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "bevel",
    fillOpacity: 0,
    pathLength: 1,
    className: "animatedPath",
    stroke: "rgb(160,143,213)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-349.6099853515625,-171.81100463867188 C-125.11000061035156,-139.81100463867188 -151.73399353027344,-285.3110046386719 -198.26499938964844,-236.8000030517578 C-248.61000061035156,-184.31100463867188 -182.51300048828125,100.16500091552734 -2.115999937057495,190.87899780273438 C185.68699645996094,285.31201171875 181.01300048828125,1.8760000467300415 181.01300048828125,1.8760000467300415 C181.01300048828125,1.8760000467300415 221.26800537109375,182.73300170898438 221.26800537109375,182.73300170898438 C221.26800537109375,182.73300170898438 204.63699340820312,23.78499984741211 204.63699340820312,23.78499984741211 C248.08999633789062,71.3949966430664 324.1579895019531,119.5009994506836 349.6099853515625,47.27000045776367"
  }))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4126)",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__element_4123)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_4152)",
    style: {
      display: "block"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.093017578125,-26.92999267578125)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,363.6830139160156,292.8110046386719)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    strokeLinejoin: "bevel",
    fillOpacity: 0,
    pathLength: 1,
    className: "animatedPath",
    stroke: "rgb(160,143,213)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M-349.6099853515625,-171.81100463867188 C-125.11000061035156,-139.81100463867188 -151.73399353027344,-285.3110046386719 -198.26499938964844,-236.8000030517578 C-248.61000061035156,-184.31100463867188 -182.51300048828125,100.16500091552734 -2.115999937057495,190.87899780273438 C185.68699645996094,285.31201171875 181.01300048828125,1.8760000467300415 181.01300048828125,1.8760000467300415 C181.01300048828125,1.8760000467300415 221.26800537109375,182.73300170898438 221.26800537109375,182.73300170898438 C221.26800537109375,182.73300170898438 204.63699340820312,23.78499984741211 204.63699340820312,23.78499984741211 C248.08999633789062,71.3949966430664 324.1579895019531,119.5009994506836 349.6099853515625,47.27000045776367"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolet);
export default __webpack_public_path__ + "static/media/violet.aa2358d282ea4a58aa57e1b4b178b3cc.svg";
export { ForwardRef as ReactComponent };